import React from 'react';
import loadable from '@loadable/component';
import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { camelize } from '../../util/string';
import { propTypes } from '../../util/types';
import FormspreeSection from '../PageBuilder/SectionBuilder/FormspreeSection/FormspreeSection';

import FallbackPage from '../LandingPage/FallbackPage';

const PageBuilder = loadable(() =>
  import(/* webpackChunkName: "PageBuilder" */ '../PageBuilder/PageBuilder')
);

const ASSET_NAME = 'artists_landing_page';

// Create a default page structure
const defaultPageData = {
  sections: [
    {
      sectionId: "contact-form",
      sectionType: "formspree-section",
      sectionName: "Contact Form"
    }
  ]
};

export const ArtistsLandingPageComponent = props => {
  const { pageAssetsData, inProgress, error } = props;

  // Merge console data with our default data
  const mergedPageData = {
    ...pageAssetsData?.artistsLandingPage?.data,
    sections: pageAssetsData?.artistsLandingPage?.data?.sections || []
  };

  return (
    <PageBuilder
      pageAssetsData={mergedPageData}
      inProgress={inProgress}
      error={error}
      fallbackPage={<FallbackPage error={error} />}
    />
  );
};

ArtistsLandingPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
  error: propTypes.error,
};

const mapStateToProps = state => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  return { pageAssetsData, inProgress, error };
};

const ArtistsLandingPage = compose(
  connect(mapStateToProps)
)(ArtistsLandingPageComponent);

export default ArtistsLandingPage; 